export default __webpack_public_path__ + "static/media/save.21e9384f.svg";